const defaultState = {};

export const settings = {
	state: defaultState,

	reducers: {},

	effects: () => ({}),
};
